import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";
import { DateTime } from "luxon";

import { useStyles } from "@/hooks/useStyles.ts";
import { NurseInclusionPatient } from "@/models/NurseInclusionPatientModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { toDateTime } from "@/utils/dateUtils.ts";

export type CreatedAtColumnProps = CellContext<NurseInclusionPatient, string>;

export const CreatedAtColumn: React.FC<CreatedAtColumnProps> = ({ getValue }) => {
  const styles = useStyles(makeStyles);

  return (
    <Typography className={styles.container} variant="body">
      {toDateTime(getValue()).toLocaleString(DateTime.DATE_SHORT)}
    </Typography>
  );
};

const makeStyles = () => ({
  container: css({}),
});
